import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'
import { take } from 'lodash'
import ScrollAnimation from 'react-animate-on-scroll'
import LazyLoad from 'react-lazyload'

import Wrapper from 'components/Wrapper'
import Section, { SectionBlock } from 'components/Section'

import { H1, Lead } from 'styles/typography'
import { white } from 'styles/colors'
import { cover } from 'styles/global'
import { media } from 'styles/media'
import * as spacing from 'styles/spacing'

const Container = styled.div`
  background-color: #161b1f;
  text-align: center;
`

const Eyebrow = styled(Lead)`
  color: ${white};
  text-transform: uppercase;
  margin-bottom: 0;
  letter-spacing: 0.1em;
`

const Heading = styled(H1)`
  color: ${white};
  font-family: 'Trim Poster';
  text-transform: uppercase;
  font-size: 40px;
  letter-spacing: 0.05em;

  ${media.small`
    font-size: 48px;
  `};

  ${media.medium`
    font-size: 56px;
  `};

  ${media.large`
    font-size: 64px;
  `};

  ${media.xLarge`
    font-size: 72px;
  `};
`

const Item = styled.a`
  position: relative;
  display: flex;
  width: 100%;

  img {
    ${cover('absolute')};
    object-fit: cover;
  }

  &:after {
    content: '';
    padding-bottom: 100%;
    display: block;
    width: 100%;
  }
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr auto;
  grid-gap: ${spacing.medium};

  ${media.medium`
    grid-gap: ${spacing.large};

    /* Hide last 3 images on larger screens */
    ${Item}:nth-last-child(-n+3) {
      display: none;
    }
  `};

  ${media.large`
    grid-gap: ${spacing.xLarge};
  `};

  ${media.xLarge`
    grid-gap: ${spacing.xxLarge};
  `};
`

const Instagram = () => {
  const { allInstagramMedia } = useStaticQuery(graphql`
    query AllInstagramMediaQuery {
      allInstagramMedia(filter: { media_type: { in: ["IMAGE", "CAROUSEL_ALBUM"] } }) {
        nodes {
          media_url
          media_type
          permalink
        }
      }
    }
  `)

  const instagramMedias = take(allInstagramMedia.nodes, 9)
  if (instagramMedias.length === 0) return null

  return (
    <Container>
      <Section>
        <Wrapper size="narrow">
          <SectionBlock>
            <ScrollAnimation animateIn="fadeInUp" offset={0} animateOnce>
              <Eyebrow>Follow us on</Eyebrow>
              <Heading as="a" target="_blank" href="https://www.instagram.com/vusecanada/">
                @vusecanada
              </Heading>
            </ScrollAnimation>
          </SectionBlock>
          <SectionBlock>
            <Grid>
              {instagramMedias.map((media, i) => (
                <Item
                  key={i}
                  href={media.permalink}
                  target="_blank"
                  as={ScrollAnimation}
                  animateIn="fadeInUp"
                  offset={0}
                  delay={i * 100 + 100}
                  animateOnce
                >
                  <LazyLoad>
                    <img src={media.media_url} />
                  </LazyLoad>
                </Item>
              ))}
            </Grid>
          </SectionBlock>
        </Wrapper>
      </Section>
    </Container>
  )
}

export default Instagram
